import { Tabs } from "radix-ui";
import { cn } from "../../../helpers/utils";

const TabTrigger = ({ value, children, isSub }) => (
  <Tabs.Trigger
    value={value}
    className={cn(
      isSub
        ? "w-full py-2 text-gray-600 font-league-small rounded-md data-[state=active]:bg-white data-[state=active]:text-[#DF2027]"
        : "px-4 py-2 text-gray-600 font-league-medium w-full data-[state=active]:border-b-4 data-[state=active]:border-vestelColor data-[state=active]:text-vestelColor"
    )}
  >
    {children}
  </Tabs.Trigger>
);

export default TabTrigger;
